import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

import { useAppContext } from "@/app/providers/app-provider"

import { WebApp } from "@/shared/telegram"

import { NavigationPanelSkeleton } from "./navigation-panel-skeleton"
import styles from "./navigation-panel.module.css"

import { navItems } from "../model"

interface NavigationPanelProps extends React.ComponentProps<"nav"> {}

export const NavigationPanel: React.FC<NavigationPanelProps> = ({ className = "", ...props }) => {
  const { t, ready } = useTranslation()
  const { impactOccurred } = WebApp.HapticFeedback
  const { chatId } = useAppContext()

  if (!ready) return <NavigationPanelSkeleton />

  const visibleNavItems = navItems.filter(item => {
    if (!chatId && item.path === "/dashboard") return true
    if (!chatId && item.requiresChatId) return false
    if (chatId && item.path === "/dashboard") return false
    return true
  })

  const handleNavigation = () => {
    impactOccurred("light")
  }

  return (
    <nav
      {...props}
      className={`${styles.navigation} ${className}`.trim()}>
      <ul>
        {visibleNavItems.map(item => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              onClick={handleNavigation}>
              <div
                className={styles["icon-container"]}
                data-pro={item.isPro ? "true" : undefined}>
                <item.icon className={styles.icon} />
              </div>
              <span className={styles.label}>{t(item.label.key, item.label.fallback)}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
